import { Space, SpaceProps } from 'antd/es';
import { SpaceCompactProps } from 'antd/es/space/Compact';
import { clsx } from 'clsx';
import React from 'react';

import s from './AntSpace.module.less';

interface Props extends SpaceProps {
  fullWidth?: boolean;
}

export const AntSpace = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { fullWidth, ...rest } = props;

  return <Space {...rest} className={clsx(rest.className, fullWidth && s.fullWidth)} ref={ref} />;
});

AntSpace.displayName = 'AntSpace';

export const AntSpaceCompact = (props: SpaceCompactProps) => {
  return <Space.Compact {...props} />;
};

AntSpaceCompact.displayName = 'AntSpaceCompact';
